import { useState, type ReactNode, type MouseEvent, Suspense } from 'react';
import type { FocusableElement } from '@react-types/shared';
import { ButtonBase, type ButtonBaseProps } from './ButtonBase';

export interface ButtonProps extends Omit<ButtonBaseProps, 'children'> {
	renderModal?: (closeModal: () => void) => ReactNode;
	useSuspense?: boolean;
}

export function Button({ renderModal, useSuspense, ...props }: ButtonProps) {
	const [showModal, setShowModal] = useState(false);

	if (!renderModal) {
		return <ButtonBase {...props} />;
	}

	const handleClick = (e: MouseEvent<FocusableElement>) => {
		e.currentTarget.blur();
		setShowModal(true);
	};

	if (!useSuspense) {
		return (
			<>
				<ButtonBase {...props} onClick={handleClick} />
				{showModal && renderModal && renderModal(() => setShowModal(false))}
			</>
		);
	}

	return (
		<Suspense fallback={<ButtonBase {...props} isPending />}>
			<ButtonBase {...props} onClick={handleClick} />
			{showModal && renderModal && renderModal(() => setShowModal(false))}
		</Suspense>
	);
}
